import { Plug } from 'lucide-react';
import type { NavItem } from './types';

/**
 * Destino «Integraciones» (§4.12): Conectores (26) y Conexiones (28). Mapeos,
 * documents and reconciliation are tabs of ONE connection, not destinations —
 * §4.12 says so explicitly: "Integraciones, where Conexiones is the listing and
 * mappings, documents and reconciliation are tabs of a connection".
 *
 * The parent node's `to` mirrors the first child (the same pattern as
 * `dtesNav`): an item WITH children expands instead of navigating (`types.ts`),
 * so that value is never used to go anywhere, but `router.test.tsx` demands it
 * resuelto.
 *
 * The `badge` §4.12 asks for (documents under review and unresolved mappings)
 * goes on the «Conexiones» child and `AppLayout` attaches it (`nav/use-nav-badges.ts`).
 *
 * There was no way to build it: `GET /connections/{id}/documents` and
 * `.../mappings` are per connection, so the total would have been one fetch per
 * active connection on every render of the shell, and the alternative —
 * approximating with a random connection — is worse than not showing it.
 * `GET /api/integrations/connections/pending-counts` was added, which does both
 * `COUNT`s in one call (C-05 of the frontend roadmap).
 */
/**
 * ⚠️ WITHOUT `minimumPhase`, and deliberately so: it is the only promise in the
 * pricing that navigation can break on its own. It is sold as the ERP being
 * integrable WHILE the SII certifies, so this destination cannot appear with a
 * "certify first" lock — that would be the app contradicting what was charged
 * for. It goes in the setup because it is part of getting everything running, but available from
 * el primer minuto.
 */
export const integrationsNav: readonly NavItem[] = [
  {
    label: 'Integraciones',
    to: '/integrations/connectors',
    icon: Plug,
    group: 'setup',
    children: [
      { label: 'Conectores', to: '/integrations/connectors' },
      { label: 'Conexiones', to: '/integrations/connections' },
    ],
  },
];
